<div class="productPage">
  <div
    [routerLink]="['../']"
    [queryParams]="{productId: product.productId}"
    *ngFor="let product of products;"
    class="productPage__item">
    <img [src]="product.imageUrl" [alt]="product.title">
    <h5>{{product.title}}</h5>
  </div>
</div>
